export function cleanNumber(number: string): string {
  return typeof number === 'string' ? number.replace(/\D/g, '') : ''
}
